import React from 'react';
import {formatCurrency} from './PublicLineItems';

function PublicAcceptedExtras({items}) {
  const selectedExtras=Array.isArray(items) ? items : [];

  return (
    <section className="proposal-section">
      <div className="proposal-heading">
        <h2>Accepted Optional Deliverables</h2>
      </div>

      {selectedExtras.length > 0 ? (
        <div className="client-options">
          {selectedExtras.map((item,index)=> (
            <div
              className="client-option selected disabled"
              key={item.id || `${item.name}-${index}`}
            >
              <span aria-hidden="true" style={{color: 'var(--green)',fontWeight: 700}}>
                ✓
              </span>
              <span>{item.name}</span>
              <strong>{formatCurrency(item.price_cents)}</strong>
            </div>
          ))}
        </div>
      ) : (
        <p
          style={{
            padding: '14px',
            background: '#f2f0ea',
            color: 'var(--muted)',
            fontSize: '12px'
          }}
        >
          No optional additional deliverables were selected.
        </p>
      )}
    </section>
  );
}

export default PublicAcceptedExtras;